import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
const useStyles = makeStyles(theme => ({
  Section: {
    padding: theme.spacing(10, 2),
    background: theme.palette.background.paper,
  },
  Container: {
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 1200,
    },
    margin: "auto",
    "& h2, & h3": {
      fontSize: theme.typography.fontSize + 20,
      fontWeight: 300,
      padding: theme.spacing(2, 0),
      marginBottom: theme.spacing(6),
    },
    "& h3": {
      marginBottom: theme.spacing(4),
    },
  },
  Item: {
    padding: "theme.spacing(2)",
  },
  imageBox: {
    margin: "auto",
    width: theme.spacing(30),
    height: theme.spacing(45),
    boxShadow: theme.shadows[3],
    background: "url('/elom-nwuneli-gloria.jpg') no-repeat",
    backgroundSize: "cover",

    [theme.breakpoints.up("md")]: {
      width: theme.spacing(40),
    },

    "& ~ p": {
      fontWeight: "700",
      textAlign: "center",
      paddingTop: theme.spacing(1),
    },
  },
  justify_mobile: {
    [theme.breakpoints.down("xs")]: {
      textAlign: "justify",
    },
  },
}))
const Team = () => {
  const classes = useStyles()
  return (
    <Box component="section" className={classes.Section} id="team">
      <Grid container className={classes.Container} spacing={4}>
        <Grid item className={classes.Item} sm={6}>
          <Typography variant="h2">OUR TEAM</Typography>
          <Typography variant="h3">
            AT THE READY TO TAKE ON YOUR EVENT PLANS WITH DETAILED EXECUTION
          </Typography>
          <Typography paragraph className={classes.justify_mobile}>
            Our Team is lead by the founder, certified event management and
            social media expert - Gloria Madoc. She has dedicated her event
            management specialties and expertise to the event and catering
            business. Gloria's experience and contributions continue to shape
            Gloone Events into what it is today, one among the event and
            catering industry's best in Nigeria.
          </Typography>
          <Typography paragraph className={classes.justify_mobile}>
            We employ staffs who are excellent communicators, who understand
            client expectations, are knowledgeable about events planning,
            managements, catering and who actually get a kick out of doing a
            superb job.
          </Typography>
        </Grid>
        <Grid
          container
          item
          className={classes.Item}
          sm={6}
          justify="center"
          alignItems="center"
          direction="column"
          spacing={6}
        >
          <Grid item>
            <Box className={classes.imageBox}></Box>
            <br></br>
            <Typography>Mrs Gloria Nwuneli Elom</Typography>
            <Typography>
              (<em>Founder</em>)
            </Typography>
          </Grid>
          <Grid item hidden>
            <Box className={classes.imageBox}></Box>
            <Typography>Cynthia Azu</Typography>
            <Typography>Caterer</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Team
